export default function noop(...args: any[]) {}
